import React, { useState, useEffect, useContext } from "react";
import "./AdvertiserLayout.css";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { API } from "../constants/Api";
import { toast } from "react-toastify";
import { ProfileUpdate } from "../App";
import { jwtDecode } from "jwt-decode";
import { Tooltip } from "@mui/material";
function AdvertiserLayout() {
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const token = localStorage.getItem("token");

  const advertiserId = localStorage.getItem("advertiserId");
  const agentEmail = localStorage.getItem("email");
  const agentName = localStorage.getItem("name");
  const agentPhone = localStorage.getItem("phone");
  const agentZipCode = localStorage.getItem("zipCode");
  const [previewImage, setPreviewImage] = useState(null);
  const [company, setCompany] = useState("");
  const [status, setStatus] = useState("");
  const [verified, setVerified] = useState(false);
  const { profileUpdateState, setProfileUpdateState } =
    useContext(ProfileUpdate);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true; // Flag to track component mount status
  
    const checkAuth = () => {
      if (advertiserId) {
        try {
          const currentDate = new Date();
          if (token) {
            const decodedToken = jwtDecode(token);
            
            if (decodedToken?.exp) {
              if (decodedToken.exp * 1000 < currentDate.getTime()) {
                console.log("Token expired.");
                // Clear advertiser data
                localStorage.removeItem("token");
                localStorage.removeItem("advertiserId");
                localStorage.removeItem("email");
                localStorage.removeItem("name");
                localStorage.removeItem("phone");
                localStorage.removeItem("zipCode");
                
                if (isMounted) {
                  navigate("/advertiser-register");
                }
                return;
              }
              // Token is valid
              if (isMounted) {
                setIsAuthChecked(true);
              }
              return;
            }
          }
        } catch (error) {
          console.error("Token decoding error:", error);
          if (isMounted) {
            navigate("/advertiser-register");
          }
          return;
        }
      }
      // No advertiser ID
      if (isMounted) {
        navigate("/advertiser-register");
      }
    };
  
    checkAuth();
  
    return () => {
      isMounted = false; // Cleanup function to avoid state updates after unmount
    };
  }, [token, location.pathname, navigate, advertiserId]);
  useEffect(() => {
    const getUserInfo = async () => {
      if (!isAuthChecked) return;
      try {
        const response = await fetch(
          `${API}/advertiser/get-Advertiser/${advertiserId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await response.json();

        if (response.ok) {
          setPreviewImage(json.data.imageUrl);
          setCompany(json.data.titleCompany);
          setStatus(json.data.accountStatus);
          setVerified(json.data.isVerified);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    getUserInfo();
  }, [profileUpdateState, token, advertiserId, isAuthChecked]);

  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [name, setName] = useState("Anya Forger");
  const [zip, setZip] = useState("9000");
  const [image, setImage] = useState(null);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" &&
      window.matchMedia("(max-width: 768px)").matches
  );

  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    const handleChange = (event) => {
      setIsMobile(event.matches);
      if (!event.matches) setIsSidebarVisible(true);
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  const handleLogout = async () => {
    const toastLoading = toast.loading("Logging out...");
    try {
      const response = await fetch(`${API}/advertiser/logout-advertiser`, {
        method: "POST",

        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const json = await response.json();
      if (response.ok) {
        localStorage.removeItem("token");
        localStorage.removeItem("advertiserId");
        localStorage.removeItem("email");
        localStorage.removeItem("name");
        localStorage.removeItem("phone");
        localStorage.removeItem("zipCode");
        toast.success(json.message);

        navigate("/");
      }
    } catch (error) {
    } finally {
      toast.dismiss(toastLoading);
    }
  };
  useEffect(() => {
    setIsSidebarVisible(false);
  }, [location.pathname]);

  if (!isAuthChecked) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
             <div className="wait-loader">
          <div className="spinner-grow text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="user-layout container-fluid pt-2 pb-2">
      <div className="row">
        <div
          className={`col-12 py-3 ${isMobile ? "" : "px-5"} user-layout-header d-flex align-items-center justify-content-between`}
        >
          <Link style={{ textDecoration: "none" }} to="/">
            <img
              src="/img/Logo.svg"
              className="img-fluid home-logo ms-2"
              alt="Logo"
            />
          </Link>
          <Link style={{ textDecoration: "none" }} to="/">
            <button className="btn logout-button">
              {/* <i className="bi bi-power me-2" /> */}
              Back To Home
            </button>
          </Link>

          {isMobile && (
            <button
              className="btn btn-outline-light"
              onClick={toggleSidebar}
              style={{
                color: "black",
                backgroundColor: "#D4BB99",
                border: "1px solid #d4bb98",
              }}
            >
              <i className="bi bi-list" />
            </button>
          )}
        </div>
      </div>
      <div className="row">
        {(!isMobile || isSidebarVisible) && (
          <div
            className={`${
              isMobile
                ? "col-12"
                : "col-md-4 col-lg-3 col-xl-3 col-xxl-2 py-3 ps-2"
            } user-layout-sidebar`}
          >
            <div className="verification-card py-0">
              <div className="verification-card-checks">
                <img src="/img/checked.svg" className="img-fluid" alt="" />
                {verified ? (
                  <img src="/img/checked.svg" className="img-fluid" alt="" />
                ) : (
                  <img
                    src="/img/uncheck.svg"
                    className="img-fluid opacity-50"
                    alt=""
                  />
                )}
                {status === "active" ? (
                  <img src="/img/checked.svg" className="img-fluid" alt="" />
                ) : (
                  <img
                    src="/img/uncheck.svg"
                    className="img-fluid opacity-50"
                    alt=""
                  />
                )}
              </div>
              <h3 className="user-layout-verify-text">
                {verified && status === "active" ? (
                  <>Active</>
                ) : !verified && status === "active" ? (
                  <>
                    Active
                    <Tooltip
                      title={<div>Please verify your email address</div>}
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: "#d4bb98",
                            color: "black",
                            fontSize: "14px",
                            borderRadius: "8px",
                            padding: "10px",
                            fontFamily: "Degular-Light",
                          },
                        },
                        arrow: {
                          sx: {
                            color: "#1e1e1e",
                          },
                        },
                      }}
                    >
                      <span
                        className="badge"
                        role="button"
                        style={{ color: "#d4bb98" }}
                      >
                        <i
                          className="bi bi-info-circle"
                          style={{ fontSize: "14px" }}
                        ></i>
                      </span>
                    </Tooltip>
                  </>
                ) : verified && status !== "active" ? (
                  <>
                    Verified
                    <Tooltip
                      title={
                        <div>Please wait till DDH activate your account</div>
                      }
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: "#d4bb98",
                            color: "black",
                            fontSize: "14px",
                            borderRadius: "8px",
                            padding: "10px",
                            fontFamily: "Degular-Light",
                          },
                        },
                        arrow: {
                          sx: {
                            color: "#1e1e1e",
                          },
                        },
                      }}
                    >
                      <span
                        className="badge"
                        role="button"
                        style={{ color: "#d4bb98" }}
                      >
                        <i
                          className="bi bi-info-circle"
                          style={{ fontSize: "14px" }}
                        ></i>
                      </span>
                    </Tooltip>
                  </>
                ) : (
                  <>
                    Pending Verification
                    <Tooltip
                      title={<div>Please verify your email address</div>}
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: "#d4bb98",
                            color: "black",
                            fontSize: "14px",
                            borderRadius: "8px",
                            padding: "10px",
                            fontFamily: "Degular-Light",
                          },
                        },
                        arrow: {
                          sx: {
                            color: "#1e1e1e",
                          },
                        },
                      }}
                    >
                      <span
                        className="badge"
                        role="button"
                        style={{ color: "#d4bb98" }}
                      >
                        <i
                          className="bi bi-info-circle"
                          style={{ fontSize: "14px" }}
                        ></i>
                      </span>
                    </Tooltip>
                  </>
                )}
              </h3>
            </div>
            <div className="user-layout-sidebar-content">
              <ul className="user-layout-nav">
                <li>
                  <Link
                    className={`user-layout-nav-items ${location.pathname === "/advertiser-auth/profile" ? "user-layout-nav-items-active" : ""}`}
                    to="/advertiser-auth/profile"
                  >
                    <img
                      src={`/img/profile-icon${location.pathname === "/advertiser-auth/profile" ? "-active" : ""}.svg`}
                      className="img-fluid"
                      alt=""
                    />
                    Profile
                  </Link>
                </li>
                <li>
                  <Link
                    className={`user-layout-nav-items ${location.pathname === "/advertiser-auth/business" ? "user-layout-nav-items-active" : ""}`}
                    to="/advertiser-auth/business"
                  >
                    <i className="bi bi-briefcase" style={{ width: "18px" }} />
                    Business Settings
                  </Link>
                </li>
                <li>
                  <Link
                    className={`user-layout-nav-items ${location.pathname === "/advertiser-auth/manage-zip" ? "user-layout-nav-items-active" : ""}`}
                    to="/advertiser-auth/manage-zip"
                  >
                    <i
                      className="bi bi-globe-americas"
                      style={{ width: "18px" }}
                    />
                    Manage Zip Codes
                  </Link>
                </li>
                {status === "active" ? (
                  <>
                    <li>
                      <Link
                        className={`user-layout-nav-items ${location.pathname === "/advertiser-auth/manage-ads" ? "user-layout-nav-items-active" : ""}`}
                        to="/advertiser-auth/manage-ads"
                      >
                        <img
                          src={`/img/tour-icon${location.pathname === "/advertiser-auth/manage-ads" ? "-active" : ""}.svg`}
                          className="img-fluid"
                          alt=""
                        />
                        Buy / Manage Ads
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={`user-layout-nav-items ${location.pathname === "/advertiser-auth/adv-chat" ? "user-layout-nav-items-active" : ""}`}
                        to="/advertiser-auth/adv-chat"
                      >
                        <img
                          src={`/img/chat-icon${location.pathname === "/advertiser-auth/adv-chat" ? "-active" : ""}.svg`}
                          className="img-fluid"
                          alt=""
                        />
                        Chat
                      </Link>
                    </li>
                  </>
                ) : (
                  <></>
                )}

                <li>
                  <Link
                    className={`user-layout-nav-items ${location.pathname === "/advertiser-auth/password" ? "user-layout-nav-items-active" : ""}`}
                    to="/advertiser-auth/password"
                  >
                    <i className="bi bi-key" style={{ width: "18px" }} />
                    Profile Settings
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        )}

        {(!isMobile || !isSidebarVisible) && (
          <div
            className={`${
              isMobile
                ? "col-12"
                : "col-md-8 col-lg-9 col-xl-9 col-xxl-10 py-3 pe-2 ps-0"
            } user-layout-content`}
          >
            <div className="container-fluid" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-12 user-layout-content-header">
                  <div className="user-layout-content-header-box">
                    <div className="user-layout-content-header-image">
                      {previewImage ? (
                        <img
                          src={previewImage}
                          className="user-layout-content-header-image-media"
                          alt=""
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="user-layout-content-header-details">
                      <h3
                        className="user-layout-content-header-details-name my-0"
                        style={{ textTransform: "capitalize" }}
                      >
                        {agentName}
                        <span className="badge rounded-pill ms-3 user-badge">
                          {company}
                        </span>
                        {isMobile ? (
                          <></>
                        ) : (
                          <span
                            className={`badge rounded-pill ms-2 ${status === "active" ? "user-badge-2-active" : "user-badge-2"}`}
                          >
                            {status === "active"
                              ? "Active"
                              : status === "deactive"
                                ? "Inactive"
                                : ""}
                          </span>
                        )}
                      </h3>

                      {/* <p className="user-layout-content-header-details-zipcode my-0">
                        Zip Code: {agentZipCode}
                      </p> */}
                      {isMobile ? (
                        <span
                          className={`badge rounded-pill ${status === "active" ? "user-badge-2-active" : "user-badge-2"}`}
                        >
                          <i
                            class={`bi bi-dot ${status === "active" ? "text-success" : "text-danger"}`}
                          ></i>{" "}
                          {status === "active"
                            ? "Active"
                            : status === "deactive"
                              ? "Inactive"
                              : ""}
                        </span>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <button onClick={handleLogout} className="btn logout-button">
                    <i className="bi bi-power me-2" />
                    Logout
                  </button>
                </div>
              </div>
              {location.pathname.includes("chat") ? (
                <>
                  <div className="row" style={{ height: "100%" }}>
                    <div
                      className={`${isMobile ? "col-12 p-0" : "col-md-12 p-0"}`}
                    >
                      <div className="user-layout-page-content">
                        <Outlet />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="row" style={{ height: "100%" }}>
                    <div
                      className={`${isMobile ? "col-12 p-0" : "col-md-9 p-0"}`}
                    >
                      <div className="user-layout-page-content">
                        <Outlet />
                      </div>
                    </div>
                    {isMobile ? (
                      <></>
                    ) : (
                      <div className="col-md-3 ps-2 pe-0">
                        <div className="user-layout-page-content">
                          remain static
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdvertiserLayout;
